'use strict'

// Crear namespace global para la aplicación si no existe
window.app = window.app || {};
// Hacer el almacén global accesible desde fuera
window.app.globalStockInfo = window.app.globalStockInfo || {};

var stockCheckTimeouts = {};
// Usar el almacén global
var globalStockInfo = window.app.globalStockInfo;

/**
 * Actualiza la visualización de disponibilidad del producto
 * @param {jQuery} productParent - Contenedor del producto
 * @param {Object} stockInfo - Información de stock del producto
 * @param {number} quantity - Cantidad seleccionada
 */
function updateAvailabilityDisplay(productParent, stockInfo, quantity) {
    var $availabilityContainer = productParent.find(".product-availability-container");
    var $unavailabilityContainer = productParent.find(".unavailability-msg-container");
    var addToCart = productParent.find('.add-to-cart');
    
    let bajoPedidotButtons = $(".js-on-request-buttons");
    let bajoPedidoProductSets = productParent.find(".js-on-request-buttons-sets");
    let inventoryRecordError = stockInfo.inventoryRecordError;
    let bajoPedido = stockInfo.bajoPedido || stockInfo.bajoPedido == 'true';
    if (quantity <= stockInfo.CANTIDAD && stockInfo.DISPONIBLE === 'SI' && !inventoryRecordError) {
        // Mostrar mensaje de disponibilidad
        if (bajoPedidotButtons && bajoPedidotButtons.length) {
            $(".hidden-by-bp").removeClass('d-none');
        }
        if (bajoPedidoProductSets && bajoPedidoProductSets.length) {
            productParent.find(".hidden-by-bp").removeClass('d-none');
        }
        $availabilityContainer.find('.dispExistencias').show();
        $availabilityContainer.find('.dispExistencias-mensaje').text(stockInfo.MENSAJE || '');
        $availabilityContainer.find('.dispExistenciasN').hide();
        $unavailabilityContainer.find('.unavailability-content').hide();
        $(".availability-product-" + stockInfo.ID_COMERCIAL).val(stockInfo.CANTIDAD);
        $(".availability-product-" + stockInfo.ID_COMERCIAL).attr("data-disponible", stockInfo.DISPONIBLE);

        addToCart.prop('disabled', false)
            .removeClass('btn-primary')
            .addClass('btn-outline-primary');
    } else if (!bajoPedido) {
        if (bajoPedidotButtons && bajoPedidotButtons.length) {
            $(".hidden-by-bp").removeClass('d-none');
        }
        if (bajoPedidoProductSets && bajoPedidoProductSets.length) {
            productParent.find(".hidden-by-bp").removeClass('d-none');
        }
        addToCart.prop('disabled', true)
            .removeClass('btn-outline-primary')
            .addClass('btn-primary');
        $unavailabilityContainer.find('.unavailability-content').show();
    } else {
        // Mostrar mensaje de no disponibilidad
        if (bajoPedidotButtons &&bajoPedidotButtons.length) {
            bajoPedidotButtons.removeClass('d-none');
        }
        if (bajoPedidoProductSets && bajoPedidoProductSets.length) {
            bajoPedidoProductSets.removeClass('d-none');
        }
        $availabilityContainer.find('.dispExistencias').hide();
        $availabilityContainer.find('.dispExistenciasN').show();
        $unavailabilityContainer.find('.unavailability-content').show();

        addToCart.prop('disabled', true)
            .removeClass('btn-outline-primary')
            .addClass('btn-primary');
    }
}

/**
 * Almacena la información de stock de todas las variaciones
 * @param {Object} sinterStock - Objeto con información de stock de todas las variaciones
 */
function storeVariationStock(sinterStock) {
    if (sinterStock && sinterStock.articulos) {
        sinterStock.articulos.forEach(function(item) {
            globalStockInfo[item.ID_COMERCIAL] = item;
        });
    }
}

/**
 * Obtiene la información de stock para un producto específico
 * @param {string} pid - ID del producto
 * @returns {Object|null} Información de stock del producto
 */
function getStoredStockInfo(pid) {
    return globalStockInfo[pid] || null;
}

/**
 * Verifica la disponibilidad de stock del producto
 * @param {jQuery} productParent - Contenedor del producto
 * @param {string} pid - ID del producto
 */
function checkStockAvailability(productParent, pid) {
    if (stockCheckTimeouts[pid]) {
        clearTimeout(stockCheckTimeouts[pid]);
    }

    stockCheckTimeouts[pid] = setTimeout(function() {
        // Verificar si ya tenemos la información en el almacén global
        var storedStockInfo = getStoredStockInfo(pid);
        var quantity = Number(productParent.find(".CantidadProd, .quantity").val() || 1);
        
        if (storedStockInfo) {
            
            updateAvailabilityDisplay(productParent, storedStockInfo, quantity);
        } else if (!globalStockInfo.isLoading) {
            // Evitar múltiples llamadas simultáneas
            globalStockInfo.isLoading = true;
            
            var getStockUrl = productParent.find('.product-availability-container').data('get-stock-url');
            if (getStockUrl) {
                $.ajax({
                    url: getStockUrl,
                    method: 'GET',
                    data: {
                        pid: pid,
                        quantity: 1
                    },
                    success: function(data) {
                        if (data.success && data.sinterStock) {
                            // Almacenar información de todas las variaciones
                            storeVariationStock(data.sinterStock);
                            
                            // Obtener la información específica para este producto
                            var productStockInfo;
                            var isBlockSale = data.blockSale || false;
                            if (isBlockSale) {
                                window.isBlockSale = true;
                                return;
                            }
                            if (data.isSet) {
                                var enableGlobalAddToCart = true;
                                data.sinterStock.articulos.forEach(function (item) {
                                    productStockInfo = getStoredStockInfo(item.ID_COMERCIAL);
                                    var itemParent = productParent.find(".product-detail.set-item[data-pid='"+ item.ID_COMERCIAL + "']");
                                    if (productStockInfo) {
                                        updateAvailabilityDisplay(itemParent, productStockInfo, quantity);
                                    }
                                    if (item.DISPONIBLE == "NO" && enableGlobalAddToCart) {
                                        enableGlobalAddToCart = false;
                                    }
                                });
                            } else {
                                productStockInfo = getStoredStockInfo(pid);
                                if (productStockInfo) {
                                    updateAvailabilityDisplay(productParent, productStockInfo, quantity);
                                }
                            }
                        } else if (data.isKohler) {
                            updateAvailabilityDisplay(productParent, {inventoryRecordError: true, DISPONIBLE: 'NO', bajoPedido: true}, quantity);
                        }
                    },
                    complete: function() {
                        globalStockInfo.isLoading = false;
                    }
                });
            }
        }
    }, 500);
}

// Manejar cambios en la cantidad
$(document).on('change', '.product-detail .CantidadProd, .product-detail .quantity', function() {
    var $this = $(this);
    var productParent = $this.parents(".uuid-" + $this.data("uuid"));
    
    if (!productParent.hasClass('isProductRcommended')) {
        var quantity = Number($this.val());
        var pid = $this.data("pid") || productParent.find(".cantidadDis").data("pid");
        var storedStockInfo = getStoredStockInfo(pid);
        
        if (storedStockInfo) {
            updateAvailabilityDisplay(productParent, storedStockInfo, quantity);
        } else {
            checkStockAvailability(productParent, pid);
        }
    }
});

$(document).on('change', '.product-card-footer .CantidadProd', function () {
    var productParent = $(this).parents(".uuid-"+$(this).data("uuid"));
    var cantidadDis = productParent.find(".cantidadDis");
    var quantity = Number($(this).val());
    var rebaseInventory = quantity > Number(cantidadDis.val());
    if (!productParent.hasClass('isProductRcommended') && quantity != 0) {
        $.ajax({
            url: cantidadDis.data("url"),
            method: 'GET',
            data: {pid: cantidadDis.data("pid"), rebaseInventory: rebaseInventory, quantity: quantity},
            success: function (data) {
                if (data && data.product && data.product.inventoryHtml) {
                    productParent.find(".availability-msg, .unavailability-msg").empty().html(data.product.inventoryHtml);
                }
            }
        });
    }
});

// Ejecutar verificación inicial cuando se carga la página
$(document).ready(function() {
    // Solo hacer una llamada inicial para el primer producto encontrado
    var $firstProduct = $('.product-detail').not('.isProductRcommended').first();
    if ($firstProduct.length) {
        var pid;
        if ($firstProduct.hasClass("product-set-detail")) {
            pid = $firstProduct.data("pid");
        } else {
            pid = $firstProduct.find(".cantidadDis").data("pid");
        }
        if (pid) {
            checkStockAvailability($firstProduct, pid);
        }
    }
});

// Manejar cambios de variación
$('body').on('product:afterAttributeSelect', function(e, response) {
    if (response.data && response.data.pid) {
        var $container = $(response.container);
        var pid = response.data.pid;
        var storedStockInfo = getStoredStockInfo(pid);
        
        if (storedStockInfo) {
            var quantity = Number($container.find(".CantidadProd, .quantity").val() || 1);
            updateAvailabilityDisplay($container, storedStockInfo, quantity);
        }
        // No hacemos una nueva llamada AJAX aquí ya que la información debería estar en globalStockInfo
    }
});
